import styled from 'styled-components'
import { themeColor } from '@elparking/components'

const mediaScreenMobile = props => `@media screen and (max-width: ${props.theme.screens.medium})`

export const SrollContainer = styled.div`
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    background: ${themeColor('white')};
    ${mediaScreenMobile} {
        height: 100vh;
    }
`
